import { Card } from '@core/design-system/card';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import { SponsoredHoc } from '../sponsored-hoc';

interface SponsoredAssetDescriptionProps {
  description: string;
  sponsoredVideo: string;
  sponsoredYoutubeVideo: string;
  isSponsored: boolean;
}

export const SponsoredAssetDescription = ({
  description,
  sponsoredVideo,
  sponsoredYoutubeVideo,
  isSponsored,
}: SponsoredAssetDescriptionProps) => {
  const showVideo =
    isSponsored && Boolean(sponsoredVideo || sponsoredYoutubeVideo);

  return (
    <SponsoredHoc isSponsored={isSponsored}>
      <Grid container spacing={1} sx={{ mt: 1 }}>
        <Grid item xs={12} md={showVideo ? 6 : 12} lg={showVideo ? 8 : 12}>
          <Card cardProps={{ sx: { height: '100%' } }}>
            <Box mb={4} display="flex" flexDirection="column" gap={2}>
              <Typography variant="body1" component="h4" fontWeight={700}>
                Descrição
              </Typography>

              <div dangerouslySetInnerHTML={{ __html: description }} />
            </Box>
          </Card>
        </Grid>

        <Grid item xs={12} md={6} lg={4}>
          {sponsoredYoutubeVideo && (
            <Box
              component="iframe"
              src={`https://www.youtube.com/embed/${sponsoredYoutubeVideo}`}
              sx={{
                width: '100%',
                height: '100%',
                minHeight: '300px',
                border: 'none',
                borderRadius: '4px',
              }}
            />
          )}
          {sponsoredVideo && !sponsoredYoutubeVideo && (
            <video
              autoPlay={false}
              controls
              style={{ width: '100%', borderRadius: '4px' }}
            >
              <source src={sponsoredVideo} />
            </video>
          )}
        </Grid>
      </Grid>
    </SponsoredHoc>
  );
};
